<template>
  <div class="d-flex align-center relative">
    <v-btn text @click="showList = !showList">
      <v-icon>mdi-bell</v-icon>
      <div v-if="notReadCount > 0" class="count-noti">
        <div>
          {{ notReadCount }}
        </div>
      </div>
    </v-btn>
    <div v-if="showList" id="list-noti" class="list" style="z-index: 100">
      <div v-if="postStaffs.length > 0">
        <div class="d-flex justify-space-between my-2">
          <div class=" ml-4">Thông báo</div>
          <div v-if="notReadCount > 0" class="mr-4 button-text" @click="readAll">Đọc tất cả</div>
        </div>
        <v-divider></v-divider>
        <div class="list-notification">
          <NotificationItem v-for="(item, index) in postStaffs" :key="index" :item="item" />
          <div v-if="postStaffs.length < totalCount" class="my-2 button-text d-flex align-center justify-center">
            <div v-if="loadmore" class="loader"></div>
            <div v-else @click="loadMore">Xem thêm</div>
          </div>
        </div>
      </div>
      <div v-else class="no-notification">
        <div>Chưa có thông báo</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import NotificationItem from './notification/NotificationItem'
export default {
  components: { NotificationItem },
  data() {
    return { showList: false, loadmore: false, el: null }
  },
  mounted() {
    this.fetch({ _limit: 10, _sort: 'createdAt:DESC', receiver: this.$auth.user.id })
    this.count({ receiver: this.$auth.user.id })
    this.countNotRead({ receiver: this.$auth.user.id })
  },
  computed: {
    ...mapState({
      postStaffs: state => state.postStaff.postStaffs,
      totalCount: state => state.postStaff.totalCount,
      notReadCount: state => state.postStaff.notReadCount
    })
  },
  methods: {
    ...mapActions({
      fetch: 'postStaff/fetch',
      readMore: 'postStaff/readMore',
      count: 'postStaff/count',
      countNotRead: 'postStaff/countNotRead',
      updateMany: 'postStaff/updateMany'
    }),
    handleClickOutside() {
      this.showList = false
    },
    readAll() {
      this.$dialog.confirm({
        title: 'Xác nhận đọc toàn bộ',
        text: `Xác nhận đọc toàn bộ?`,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.updateMany({ isRead: true })
            this.fetch({ _limit: 10, receiver: this.$auth.user.id })
            this.countNotRead({ receiver: this.$auth.user.id })
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    },
    async loadMore() {
      try {
        this.loadmore = true
        await this.readMore({ receiver: this.$auth.user.id })
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.loadmore = false
      }
    }
  }
}
</script>

<style scoped>
.relative {
  position: relative;
}
.count-noti {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: red;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  text-align: center;
  color: white;
  font-size: 10px;
}
.list {
  position: absolute;
  top: 50px;
  right: 0;
  width: 400px;
  height: 340px;
  background-color: white;
  border: 1px solid #e0e0e0;
}
.list-notification {
  overflow-y: scroll;
  height: 298px;
}
.button-text {
  text-align: center;
  color: #0d47a1;
  cursor: pointer;
}
.text-center {
  text-align: center;
}
.no-notification {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader {
  width: 10px;
  aspect-ratio: 1;
  border-radius: 50%;
  animation: l5 1s infinite linear alternate;
}
@keyframes l5 {
  0% {
    box-shadow: 20px 0 #000, -20px 0 #0002;
    background: #000;
  }
  33% {
    box-shadow: 20px 0 #000, -20px 0 #0002;
    background: #0002;
  }
  66% {
    box-shadow: 20px 0 #0002, -20px 0 #000;
    background: #0002;
  }
  100% {
    box-shadow: 20px 0 #0002, -20px 0 #000;
    background: #000;
  }
}
</style>
